import { React, useState, useMemo, useContext } from "react";
import Table from "./Table";
import { TableHeaderContext } from "../Contexts/TableHeaderContext";
import { PeFilterContext } from "../Contexts/PeFilterContext";
import DealsTable from "./DealsTable";

/**
 * The TableComponent function renders a table based on the menu selection and displays the data and
 * pagination.
 * @param props - The `props` parameter is an object that contains the properties passed to the
 * `TableComponent` component. These properties can be accessed using dot notation, such as
 * `props.menu` to access the `menu` property.
 * @returns The TableComponent is being returned.
 */
const TableComponent = (props) => {
  const {
    PEVCTableHeader,
    PEVCDealsTableHeader,
    PEVCExitDealsTableHeader,
    VCExitPMDealsTableHeader ,
    VCTableHeader,
    PEVCExitTableHeader,
    PEVCExitMATableHeader,
    PEVCExitMADealsTableHeader,
    PEVCExitPMTableHeader,
    PEVCExitPMDealsTableHeader,
    VCExitMATableHeader,
    VCExitMADealsTableHeader,
    VCExitPMTableHeader,
    PEVCBackedIposTableHeader,
    PEVCBackedIposDealsTableHeader,
    // VCBackedIposTableHeader,
    AngelInvestmentsTableHeader,
    IncubationTableHeader,
    //  investorTableHeader,
    orderBy,
    orderBya,
    OrderByVCTableHeader,
    OrderByPEVCExitMATableHeader,
    OrderByPEVCExitPMTableHeader,
    OrderByVCExitMATableHeader,
    OrderByVCExitPMTableHeader,
    OrderByPEVCBackedIposTableHeader,
    // OrderByVCBackedIposTableHeader,
    OrderByAngelInvestmentsTableHeader,
    OrderByIncubationTableHeader,
    // VCAngelInvestmentsTableHeader,VCIncubationTableHeader
    orderingColumn,
    exitOrderingColumn,
  } = useContext(TableHeaderContext);

  const { dealsView } = useContext(PeFilterContext);
  const [
    investments,
    //  setInvestments
  ] = useState([]);
  const [
    pagination,
    //  setPagination
  ] = useState();

  // Memoize columns selection logic for better performance
  const columns = useMemo(() => {
    const getColumnsForMenu = (menuType, dealsViewEnabled) => {
      const menuColumnMap = {
        'pe': !dealsViewEnabled ? PEVCTableHeader : PEVCDealsTableHeader,
        'vc': !dealsViewEnabled ? PEVCTableHeader : PEVCDealsTableHeader,
        'exit-pe-vc': !dealsViewEnabled ? PEVCExitTableHeader : PEVCExitDealsTableHeader,
        'exit-ma-pe-vc': !dealsViewEnabled ? PEVCExitMATableHeader : PEVCExitMADealsTableHeader,
        'exit-pm-pe-vc': !dealsViewEnabled ? PEVCExitPMTableHeader : PEVCExitPMDealsTableHeader,
        'exit-ma-vc': !dealsViewEnabled ? VCExitMATableHeader : VCExitMADealsTableHeader,
        'vc_exit': !dealsViewEnabled ? VCExitMATableHeader : VCExitMADealsTableHeader,
        'exit-pm-vc': !dealsViewEnabled ? VCExitPMTableHeader : VCExitPMDealsTableHeader,
        'backedIpos-pe-vc': !dealsViewEnabled ? PEVCBackedIposTableHeader : PEVCBackedIposDealsTableHeader,
        'backedIpos-vc': !dealsViewEnabled ? PEVCBackedIposTableHeader : PEVCBackedIposDealsTableHeader,
        'angel': AngelInvestmentsTableHeader,
        'incubation': IncubationTableHeader,
        'vc-angel': AngelInvestmentsTableHeader,
        'vc-incubation': IncubationTableHeader
      };
      return menuColumnMap[menuType] || PEVCTableHeader;
    };

    return getColumnsForMenu(props.menu, dealsView);
  }, [
    props.menu, 
    dealsView,
    PEVCTableHeader,
    PEVCDealsTableHeader,
    PEVCExitTableHeader,
    PEVCExitDealsTableHeader,
    PEVCExitMATableHeader,
    PEVCExitMADealsTableHeader,
    PEVCExitPMTableHeader,
    PEVCExitPMDealsTableHeader,
    VCExitMATableHeader,
    VCExitMADealsTableHeader,
    VCExitPMTableHeader,
    PEVCBackedIposTableHeader,
    PEVCBackedIposDealsTableHeader,
    AngelInvestmentsTableHeader,
    IncubationTableHeader
  ]);

  // Memoize order by selection logic
  const orderByValue = useMemo(() => {
    const orderByMap = {
      'pe': orderingColumn,
      'vc': OrderByVCTableHeader,
      'exit-pe-vc': exitOrderingColumn,
      'exit-ma-pe-vc': exitOrderingColumn,
      'exit-pm-pe-vc': exitOrderingColumn,
      'exit-ma-vc': exitOrderingColumn,
      'vc_exit': exitOrderingColumn,
      'exit-pm-vc': exitOrderingColumn,
      'backedIpos-pe-vc': exitOrderingColumn,
      'backedIpos-vc': exitOrderingColumn,
      'angel': exitOrderingColumn,
      'incubation': exitOrderingColumn,
      'vc-angel': exitOrderingColumn,
      'vc-incubation': exitOrderingColumn
    };
    return orderByMap[props.menu] || orderingColumn;
  }, [props.menu, orderingColumn, OrderByVCTableHeader, exitOrderingColumn]);

  const tableRowData = useMemo(() => investments, [investments]);
  const paginationData = useMemo(() => pagination, [pagination]);
  

  return (
    <div className="pl-3 pr-2 lg:pr-2 md:pr-3 overflow-y-auto">
      {/* {console.log("investments", tableRowData)} */}
      <div className="App lg:relative">
        {dealsView ? (
          <DealsTable
            order="desc"
            orderBy={orderByValue}
            menu={props?.menu}
            columns={columns}
            pagination={paginationData}
            sub_type_master_id={props?.sub_type_master_id}
          />
        ) : (
          <Table
            order="desc"
            orderBy={orderByValue}
            menu={props?.menu}
            columns={columns}
            pagination={paginationData}
            sub_type_master_id={props?.sub_type_master_id}
          />
        )}
      </div>
    </div>
  );
};

// Set display name for better debugging
TableComponent.displayName = 'TableComponent';

export default TableComponent;
